import { __decorate, __metadata } from 'tslib';
import { ControllerRegistry } from '../../registries/controller-registry.js';
import { Service } from '../../decorators/class/service.js';
import { ServiceCollection } from '../service-collection.js';
import { BuiltinUiState } from '../store/builtin-state.js';
import { StateManager } from '../store/state-manager.js';
import SchematicUIService from '../../controllers/base/schematic-ui-service.js';
import { ITEM_NAME_TO_SERVICE_NAME } from '../../constants/ui-service-item-name.js';

/**
 * scope级别开关。provider上标记scope相同的，将被一起关掉。拥有最高优先级
 * @public
 */
let ConfigScopeService = class ConfigScopeService {
    constructor(serviceCollection, store) {
        this.serviceCollection = serviceCollection;
        this.store = store;
        // scope级别开关
        this.disabledScopes = new Set();
        this.store.register(BuiltinUiState.ScopeStatus, this.disabledScopes);
    }
    /**
     * 设置scope级别的开关。provider上标记scope相同的，将被一起关掉。拥有最高优先级
     * @param name - scope的名称
     */
    disableByScope(name) {
        this.disabledScopes.add(name);
        this.store.update(BuiltinUiState.ScopeStatus, this.disabledScopes);
        this.updateUIService(name);
    }
    /**
     * 开启scope级别的开关。若controller被关了依然会被关闭
     * @param name - scope的名称
     */
    enableByScope(name) {
        this.disabledScopes.delete(name);
        this.store.update(BuiltinUiState.ScopeStatus, this.disabledScopes);
        this.updateUIService(name);
    }
    updateUIService(scopeName) {
        const services = this.getUIServiceToBeUpdate(scopeName);
        services.forEach((serviceName) => {
            const service = this.serviceCollection.getControllerRelatedUIServices().get(serviceName);
            if (service instanceof SchematicUIService) {
                service.$forceUpdate();
            }
        });
    }
    /**
     * 获取controller影响的ui service名称
     */
    getUIServiceToBeUpdate(scopeName) {
        var _a;
        const iter = ControllerRegistry.values();
        let result = iter.next();
        const uiServices = new Set();
        let provideOption;
        while (!result.done) {
            provideOption = result.value;
            if ((_a = provideOption === null || provideOption === void 0 ? void 0 : provideOption.customScope) === null || _a === void 0 ? void 0 : _a.includes(scopeName)) {
                this.checkNeedToUpdate(provideOption, uiServices);
            }
            result = iter.next();
        }
        return uiServices;
    }
    checkNeedToUpdate(provideOption, uiServices) {
        Object.keys(provideOption).forEach((key) => {
            const serviceName = ITEM_NAME_TO_SERVICE_NAME[key];
            if (serviceName && Array.isArray(provideOption[key]) && provideOption[key].length > 0) {
                uiServices.add(serviceName);
            }
        });
        return uiServices;
    }
};
ConfigScopeService = __decorate([
    Service({ overridable: true }),
    __metadata("design:paramtypes", [ServiceCollection,
        StateManager])
], ConfigScopeService);

export { ConfigScopeService };
//# sourceMappingURL=config-scope-service.js.map
